import { animate, splitText, stagger } from '../vendor/anime.esm.js';
import { registerPostRender } from '../core/render.js';
import { store } from '../core/store.js';
import { DURATION, EASE, resolveDuration } from './motion-tokens.js';

/**
 * TEXTOS CINEMÁTICOS (Fase 1D)
 * Animaciones premium para tipografía de display (Hero, Banner)
 * Aplica SplitText nativo de Anime.js v4.
 */

export function initSplitText() {
    // Reglas estrictas:
    // 1. Nunca animar en modo editor
    // 2. Nunca animar si el usuario prefiere movimiento reducido
    const PREFERS_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (store.get('editorMode') || PREFERS_REDUCED_MOTION) return;

    // Solo arrancar cuando las fuentes estén cargadas para evitar FOUT (Flash of Unstyled Text)
    // El LLM define la fuente (--font-display), por tanto necesitamos que el navegador ya la haya pintado.
    document.fonts.ready.then(() => {
        
        // --- HERO: eliminado — variant-animations.js heroV1/V2/V3 ya lo cubre ---
        // --- BANNER: eliminado — variant-animations.js bannerAnim() ya lo cubre ---
        // --- CTA-BAR: eliminado — variant-animations.js ctaBar() ya lo cubre ---

        // Nota: Este módulo queda como hook de document.fonts.ready.
        // Si se añaden nuevos bloques sin variantFn que necesiten splitText,
        // se pueden registrar aquí.
    });
}

// Registrar en el ciclo de vida (solo en vista final)
registerPostRender(initSplitText, { previewOnly: true });
